/* eslint-disable jsx-a11y/control-has-associated-label */
import CloseIcon from '@mui/icons-material/Close';
import { Radio, RadioGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ICollaboratorViewModel, IProfileViewModel } from 'viewModels';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/iconExclamation.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/iconUser.svg';
import { CompanyController } from '../../../controller/CompanyController';
import { BasicButton } from '../../Buttons/BasicButton';
import { ContentModal, Header } from './styles';
import { useAlert } from '../../../hooks/useAlert';

interface ModalDeleteProfileProps {
  isOpen: boolean;
  profiles: IProfileViewModel[];
  currentProfileId?: string;
  onRequestClose: () => void;
}

export function ModalDeleteProfile({
  profiles,
  currentProfileId,
  isOpen,
  onRequestClose,
}: ModalDeleteProfileProps) {
  const alert = useAlert();
  const [collaborators, setCollaborators] = useState<ICollaboratorViewModel[]>([]);
  const [toProfileId, setToProfileId] = useState('');
  const [hasError, setHasError] = useState(false);

  const handleDeleteAndTransferProfile = async () => {
    if (!toProfileId) {
      setHasError(true);
      return;
    }

    await CompanyController.deleteProfile(toProfileId, currentProfileId).then(() => {
      alert.show({ message: 'Perfil excluido e transferido com sucesso', type: 'success' });
      handleRequestClose();
    });
  };

  const handleDeleteProfile = async () => {
    await CompanyController.deleteProfile(toProfileId, currentProfileId).then(() => {
      alert.show({ message: 'Perfil excluido com sucesso', type: 'success' });
      handleRequestClose();
    });
  };
  const handleRequestClose = () => {
    onRequestClose();
    setHasError(false);
    setToProfileId('');
  };

  useEffect(() => {
    if (currentProfileId)
      CompanyController.getCollaboratorsByProfileId(currentProfileId).then((response) =>
        setCollaborators(response),
      );
  }, [currentProfileId]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-delete-profile-modal-content">
      <Header>
        <div className="subHeader">
          <ExclamationIcon />
          <h1>Deseja realmente excluir o perfil?</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      {collaborators.length > 0 ? (
        <ContentModal>
          <h3>Escolha um perfil para transferir as pessoas cadastradas</h3>
          <h2>Perfil</h2>
          <div className="containerProfiles">
            <RadioGroup
              name="transfer"
              children={profiles
                .filter((p) => p.id !== currentProfileId)
                .map((p) => (
                  <div key={p.id} className="groupRadio">
                    <Radio
                      value={p.id}
                      id={p.id}
                      onChange={() => {
                        setToProfileId(p.id);
                        setHasError(false);
                      }}
                    />
                    <label htmlFor={p.id}>{p?.name} </label>
                  </div>
                ))}
            />
          </div>
          {hasError && <p className="fieldError">Selecione um perfil para transferir</p>}
          <h2>Pessoas cadastradas</h2>
          <div className="containerCollaborators">
            {collaborators.map((c) => (
              <div className="contentCollaborators" key={c.id}>
                <p>
                  <UserIcon />
                  {c.firstName}
                </p>
              </div>
            ))}
          </div>
          <div className="transferConfirmation">
            <BasicButton
              type="button"
              variant="contained"
              size="large"
              onClick={handleDeleteAndTransferProfile}>
              Excluir e transferir
            </BasicButton>
          </div>
        </ContentModal>
      ) : (
        <ContentModal>
          <div className="transferConfirmation">
            <BasicButton
              type="button"
              variant="contained"
              size="large"
              onClick={handleDeleteProfile}>
              Excluir
            </BasicButton>
          </div>
        </ContentModal>
      )}
    </Modal>
  );
}
